var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { useState, useEffect, useMemo, useRef } from 'react';
import { useSearchAdornment } from '../../Adornment';
import { variantPreFilter, containsFocus } from '../utils';
import { useDebounce } from '../../../../tools/utils';
export var useInputSelectState = function (_a) {
    var variant = _a.variant, options = _a.options, inputWrapperRef = _a.inputWrapperRef, inputValue = _a.inputValue, minSearchChars = _a.minSearchChars, maxDisplayedOptions = _a.maxDisplayedOptions, isLoading = _a.isLoading;
    var staticPrevInputValue = useRef('');
    var filteredOptions = useMemo(function () {
        var variantOptions = variantPreFilter(variant, options);
        return variantOptions.length > maxDisplayedOptions
            ? variantOptions.slice(0, maxDisplayedOptions)
            : variantOptions;
    }, [variant, maxDisplayedOptions, options]);
    var _b = __read(useState(false), 2), isMounted = _b[0], setMounted = _b[1];
    var _c = __read(useState(false), 2), showOptions = _c[0], setShowOptions = _c[1];
    var _d = __read(useState(false), 2), showLoading = _d[0], setShowLoading = _d[1];
    var setClickCallback = useSearchAdornment().setClickCallback;
    // debouncing to give options a chance to update after load complete
    var debounceShowLoading = useDebounce({
        debounceTimeout: 100,
        onDebounced: setShowLoading,
    }).handleValueChange;
    useEffect(function () {
        setMounted(true);
        // sets the click callback for the search adornment button
        setClickCallback(function () { return setShowOptions(true); });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    useEffect(function () {
        if (containsFocus(inputWrapperRef) &&
            inputValue.length >= minSearchChars &&
            showLoading !== isLoading) {
            if (showLoading)
                debounceShowLoading(false);
            else
                setShowLoading(true);
        }
        // do not add showLoading to the dependency array
        // we don't want to update based on the state we're setting
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isLoading, inputValue, minSearchChars]);
    useEffect(function () {
        var prevValue = staticPrevInputValue.current;
        if (inputValue.length < minSearchChars) {
            if (showOptions)
                setShowOptions(false);
            if (showLoading)
                setShowLoading(false);
        }
        else if (containsFocus(inputWrapperRef) &&
            prevValue.length !== inputValue.length) {
            if (!showOptions)
                setShowOptions(true);
        }
        if (prevValue !== inputValue) {
            staticPrevInputValue.current = inputValue;
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [minSearchChars, inputValue]);
    return {
        filteredOptions: filteredOptions,
        showOptions: showOptions,
        showLoading: showLoading,
        setShowOptions: setShowOptions,
        setShowLoading: setShowLoading,
        isMounted: isMounted,
    };
};
//# sourceMappingURL=useInputSelectState.js.map